const signUp = {
  state: {
    student: {},
    questions: [],
  },
  mutations: {
    ADD_PERSONAL_DATA: (state, data) => {
      state.student = data;
    },
    ADD_ANSWER_DATA: (state, data) => {
      state.questions = data;
    },
  },
  actions: {
    addToStore({commit}, data) {
      commit('ADD_PERSONAL_DATA', data);
    },
    addToAnswer({commit}, data) {
      commit('ADD_ANSWER_DATA', data);
    },
  },
  getters: {
    getPersonalData: (state) => state.student,
    getAnswerData: (state) => state.questions,
  },
};

export default signUp;